import(/* webpackMode: "eager" */ "/var/www/vhosts/zoyaspantry.com.au/httpdocs/frontend/src/app/(auth)/register/page.js");
